import { Component, inject, OnDestroy, OnInit, DoCheck } from '@angular/core';
import { SabisGrid2Component } from 'sabis-grid2';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription, tap } from 'rxjs';
import { BreadcrumbService } from 'src/app/@theme/shared/components/breadcrumb/breadcrumb.service';
import { RouteCachingService } from './../../@theme/shared/services/route-caching.service';
import { DashboardService } from '../dashboard.service';
import { toParams } from 'src/app/shared/lazy-loading';
import { ColumnSettings, ColumnType, LoadDataEvent, PagedData } from 'sabis-grid2';
import { ReuseComponent } from './../../shared/routing/routing.model';
import { ReusableComponent } from 'src/app/core/caching/resusable-component.component';
import { GeneralApplicationsDashboardDTO, GeneralApplicationsDashboardListFilterDTO } from 'src/app/reports/models/api-models';

@Component({
  selector: 'sca-general-applications-dashboard',
  templateUrl: './general-applications-dashboard.component.html',
  styleUrls: ['./general-applications-dashboard.component.scss'],
  imports: [SabisGrid2Component]
})
export class GeneralApplicationsDashboardComponent extends ReusableComponent implements OnInit, OnDestroy, DoCheck {
  private _routeParamsSubscription = new Subscription();
  private _routeCachingService: RouteCachingService;

  public isLoading: boolean = true;
  public columns: ColumnSettings[] = [];
  public getUnprocessedApplications: boolean = false;
  public title: string = '';

  constructor(private _route: ActivatedRoute,
    private _breadcrumb: BreadcrumbService,
    private _dashboardService: DashboardService) {
    super();
    this._routeCachingService = inject(RouteCachingService);

    this.dataLoader = this.dataLoader.bind(this);
    this.onView = this.onView.bind(this);
  }

  ngOnInit(): void {
    this._routeParamsSubscription = this._route.queryParams.subscribe(routeParams => {
      let unprocessedQueryValue = routeParams['unprocessed'];

      if (!unprocessedQueryValue) {
        this.getUnprocessedApplications = false;

        return;
      }

      this.getUnprocessedApplications = unprocessedQueryValue == "true";
    });

    this.columns = [
      { field: '', title: '', type: ColumnType.action, actionSettings: { name: 'View', callback: this.onView } },
      { field: 'countryName', title: 'Country', type: ColumnType.text },
      { field: 'applicationsCount', title: 'Applications Count', type: ColumnType.numeric }
    ];
  }

  ngDoCheck(): void {
    // The title is set in this method because it's not set correctly when clicking "Back" button from candidates (using of route reuse strategy),
    // but it's displaying the original title from the route settings
    const pageTitle = this.getUnprocessedApplications ? 'Unprocessed General Applications' : 'General Applications';
    this._breadcrumb.setCustomTitle(pageTitle);
  }

  override ngOnDestroy(): void {
    this._routeParamsSubscription.unsubscribe();
  }

  public dataLoader(event: LoadDataEvent): Observable<PagedData<GeneralApplicationsDashboardDTO>> {
    this.isLoading = true;

    let params: GeneralApplicationsDashboardListFilterDTO = {
      queryParams: toParams(event),
      getUnprocessedApplications: this.getUnprocessedApplications ? !!this.getUnprocessedApplications : false
    }

    // load entity general applications
    return this._dashboardService.GetMyGeneralApplicationsDashboard(params).pipe(
      tap(_ => {
        this.isLoading = false;
      })
    );
  }

  public onView(dataItem: GeneralApplicationsDashboardDTO): void {
    this._routeCachingService.clearCachedRoute(ReuseComponent.RequisitionCandidatesListComponent);
    // redirect to applications list
    this._dashboardService.myGeneralApplicationsSelected(dataItem.countryId, this.getUnprocessedApplications);
  }
}
